import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { type IDistrict } from "../../api/districts/districts.interface";
import { logout } from "../user/slice";

import { districtInitialState } from "./state";

export const slice = createSlice({
  initialState: districtInitialState,
  name: "district",
  reducers: {
    resetDistrictState: () => districtInitialState,
    setDistricts: (state, action: PayloadAction<IDistrict[]>) => {
      state.items = action.payload;
    },
    setSelectedDistrict: (state, action: PayloadAction<IDistrict | null>) => {
      state.selectedDistrict = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => districtInitialState);
  },
});

export default slice.reducer;

export const {
  resetDistrictState,
  setDistricts,
  setSelectedDistrict,
} = slice.actions;

